export default "assets/images/icons/arrow-wine-07c70729.svg";